
import getLicensePlateColor from '../../functions/extensions/lpColors'
import { states } from '../../GlobalVars'

const BannerLicensePlate = ({
    stateAndLicensePlate,
    isMobile
}) => {

    // LP colors
    const findKeyByValue = (obj, value) => {
        return Object.keys(obj).find(key => obj[key] === value)

    };

    let plateState = stateAndLicensePlate.split('-')[0]
    let licensePlate = stateAndLicensePlate.split('-')[1]

    const key = findKeyByValue(states, plateState)

    const { licensePlateColor, fontColor, fontColor2 } = getLicensePlateColor(plateState);

    return (

        <div>
            <div
                className={`flex flex-col w-[75px] border-[1.5px] border-gray-100 rounded-[3px] justify-center items-center shadow-gray-600 shadow-sm relative`}
                style={{ 
                    height: 35, 
                    backgroundColor: plateState === "" ? '#ffffff' : licensePlateColor,
                    transform: !isMobile ? 'scale(2)' : '',
                    right: !isMobile ? 0 : 0,
                    top: !isMobile ? 0 : 0
                }}
            >

                {/* state */}
                <p
                    className={`font-lpFont text-[7px] scale-y-75 relative top-[2px]`}
                    style={{ color: fontColor2 }}>
                    {(states[plateState]?.toUpperCase())}

                </p>

                {/* plate number */}
                <p
                    className={`font-lpFont text-[17px] relative top-[0.5px]`}
                    style={{ color: fontColor }}
                >
                    {licensePlate?.toUpperCase()}
                </p>


            </div>
        </div>
    )
}

export default BannerLicensePlate
